import { LatLngAlt } from "../../../types.js";

const stream: LatLngAlt[] = [
  [-11.64753, 166.951997, 14.6],
  [-11.64755, 166.952126, 15],
  [-11.647573, 166.952233, 15.4],
  [-11.647593, 166.952341, 15.4],
  [-11.647617, 166.952437, 15.4],
  [-11.647679, 166.952534, 15.4],
  [-11.647774, 166.952598, 15.6],
  [-11.647884, 166.952641, 15.6],
  [-11.647998, 166.952652, 15.6],
];

export default stream;
